import type { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  text?: ReactNode;
  /** L'action qui permet de sortir de l'état vide (créer, réessayer…). */
  action?: ReactNode;
}

export function EmptyState({ icon, title, text, action }: EmptyStateProps) {
  return (
    <div className="ui-empty">
      {icon && <div className="ui-empty__icon">{icon}</div>}
      <div className="ui-empty__title">{title}</div>
      {text && <div className="ui-empty__text">{text}</div>}
      {action && <div className="ui-empty__action">{action}</div>}
    </div>
  );
}
